import React from "react";
import { Badge, Text, Tooltip } from "@merge-api/merge-javascript-shared";

// TODO: remove the muted "New" callout (badge + tooltip) after ~2026-10-15
// Flat version for aria-label / screen readers (the visual tooltip below is two lines).
const ISSUE_MUTED_NOTICE =
  "You'll now also be alerted when an issue is muted. The created and resolved alerts you already receive are unchanged.";

// Edit-mode copy for the Linked Account issues card. Calls out that muted specifically is the
// new event (created and resolved already existed); the "New" badge is the tooltip trigger.
function IssuesMutedDescription() {
  return (
    <>
      Receive an alert when a Linked Account issue is created, muted{" "}
      <Tooltip
        variant="white"
        title={
          <div className="flex flex-col gap-1">
            <Text variant="sm">You&apos;ll now also be alerted when an issue is muted.</Text>
            <Text variant="sm">
              The created and resolved alerts you already receive are unchanged.
            </Text>
          </div>
        }
      >
        {/* The "New" badge is the tooltip trigger. A real button gives focus + keyboard
            activation; type="button" so it never submits the surrounding webhook form; and
            stopPropagation keeps the click from toggling the card selection. */}
        <button
          type="button"
          aria-label={ISSUE_MUTED_NOTICE}
          onClick={(e) => e.stopPropagation()}
          className="inline-flex cursor-help border-0 bg-transparent p-0 align-middle"
        >
          <Badge size="sm" color="blue">
            New
          </Badge>
        </button>
      </Tooltip>
      , or resolved.
    </>
  );
}

export default IssuesMutedDescription;
